import {
  type IndustrialPremises,
  type IndustrialPremisesRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';

// Custom handler for industrial premises to include revenue rows
export const handleCustomIndustrialPremisesNestedCase = createBaseRentHandler<
  IndustrialPremises,
  IndustrialPremisesRevenueRow
>('industrialpremisesrevenuerow');
